/**
 * @module support/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const CPS_ROUTES = {
  CHANGE_PLAN: '/change-plans-services/rate-plans',
  CHANGE_SERVICES: '/change-plans-services/rate-services',
  SET_EFFECTIVE_DATE: '/change-plans-services/set-effective-date',
  SESSION_PASS: '/change-plans-services/session-pass',
  SESSION_PASS_SET_EFFECTIVE_DATE: '/change-plans-services/session-pass-set-effective-date',
  LINE_SELECTOR: '/line-selector',
};

export const MANAGE_PROFILE = {
  CHANGE_BILLING_ADDRESS: '/my-profile/billing-address',
  SEGMENTATION: '/my-profile/segmentation',
  PROFILE_INFO: '/my-profile/profile-info',
};

export const CART_ROUTES = {
  PAYMENT: '/cart/payment',
  PAYMENT_RETAIL: '/cart/payment/instore',
  SHIPPING: '/cart/shipping',
  CART_REVIEW: '/cart/review',
  ORDER_REVIEW: '/cart/order-review',
  ACCOUNT_SETUP: '/cart/account-setup',
  LINE_SETUP: '/cart/line-setup',
  PAYMENT_SHIPTO: '/cart/payment/shipTo',
};

export const ORDER_CONFIRMATION = {
  HOME: '/home',
  ACCOUNT_LANDING: '/account-landing',
  ORDER_CONFIRMATION_ROUTE: '/order-confirmation',
};

export const EBB_ROUTES = {
  EBB_ELIGIBILITY: '/ebb',
  EBB_LANDING: '/ebb/ebb-request-form',
  ACCOUNT_LANDING: '/account-landing',
  MY_PROFILE: '/my-profile',
  EBB_REQUEST_CONFIRMATION: '/ebb/ebb-request-confirm',
};
